import { logout as clearAuth } from '@/store';
import { useLogoutMutation } from '@/store/api/authApi';
import React from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const [logout] = useLogoutMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // await logout().unwrap();
      dispatch(clearAuth());
      toast.success('You have been logged out successfully.');
      navigate('/login');
    } catch (err: any) {
      console.error('Logout failed:', err);
      toast.error(err?.data?.message || 'Failed to logout. Please try again.');
    }
  };
  // useGetUserQuery(undefined, { pollingInterval: 5000 });
  return (
    <header className="fixed top-0 left-0 z-[99] w-full bg-primary/50 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-[1200px] mx-auto flex items-center justify-between px-3 sm:px-6 py-3">
        {/* Left Nav */}
        <div className="flex items-center gap-x-4">
          <Link to="/">
            <img src={'/images/login/logo.png'} alt="logo" className="h-9 max-w-[140px]" />
          </Link>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-2 text-sm">
          <button
            onClick={handleLogout}
            className="w-20 sm:w-24 bg-white text-gray-800 font-medium px-3 py-1.5 rounded-md border border-gray-200 hover:shadow-sm transition"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
